<div *ngIf="qprams['method_type']!=='other'" class="payment-wallet-wrapper">
  <app-payment-method-list *ngIf="config?.paymentOptions?.options?.TOPWALLET" [config]="config"
                          [listConfig]="{
                            wrapClass: 'wallet',
                            list: config?.paymentOptions?.options?.TOPWALLET,
                            type: 'radio',
                            showSubmitBtn: isMobile ? true : false,
                            showIcon: true
                          }"
                          (submitPayment)="submit($event)" (onChange)="selectedWallet=$event">
  </app-payment-method-list>

  <div *ngIf="!isMobile && config?.paymentOptions?.options?.WALLET" class="wallet-dropdown">
    <app-payment-method-dropdown [dropDownConfig]="{
                                    inputAppearance: config?.inputAppearance,
                                    wrapClass: 'wallet-dropdown',
                                    selectPlaceHolder: 'Select Wallet',
                                    list: config?.paymentOptions?.options?.WALLET,
                                    selectedOption: selectedWallet
                                  }"
                                  (dataEmit)="submit($event)">
    </app-payment-method-dropdown>
  </div>
</div>

<div *ngIf="isMobile" class="other-wallet-list">
  <app-payment-other-method-list [config]="config" [otherOptionsConfig]="{
                                    inputAppearance: config?.inputAppearance,
                                    wrapClass: 'wallet-other-options',
                                    otherSelectTitle: 'SELECT OTHER WALLET',
                                    selectPlaceHolder: 'Select Wallet',
                                    list: config?.paymentOptions?.options?.WALLET
                                  }"
                                  (dataEmit)="submit($event)">
  </app-payment-other-method-list>
</div>
